<h1>
    Oops! That page doesn't exist. Please select a link below.
  </h1>
<nav>
    <a routerLink="/" routerLinkActive="active">
      <button>Home</button>
    </a>
    <a routerLink="/search-repo" routerLinkActive="active">
      <button>Search For Repositories</button>
    </a>
    <a routerLink="/search-user" routerLinkActive="active">
        <button>Search For Users</button>
    </a>
  </nav>